import {NonHomeVidItem, LinkEl, ThumbnailImg} from './styledComponents'

import {
  Duration,
  ViewsCnt,
  ViewsAndDurationContainer,
  ChannelName,
  VideoTitle,
  AboutVideoContainer,
} from '../HomePageVideoItem/styledComponents'
import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const NonHomeVideoItem = props => {
  const {details} = props
  const {
    id,
    title,
    thumbnailUrl,
    channel,
    viewCount,
    publishedDuration,
  } = details
  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode} = value
        return (
          <LinkEl to={`videos/${id}`}>
            <NonHomeVidItem>
              <ThumbnailImg src={thumbnailUrl} alt="video thumbnail" />
              <AboutVideoContainer>
                <VideoTitle darkMode={darkMode}>{title}</VideoTitle>
                <ChannelName>{channel.name}</ChannelName>
                <ViewsAndDurationContainer>
                  <ViewsCnt>{viewCount} views</ViewsCnt>
                  <Duration>{publishedDuration} ago</Duration>
                </ViewsAndDurationContainer>
              </AboutVideoContainer>
            </NonHomeVidItem>
          </LinkEl>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}

export default NonHomeVideoItem
